unit AddressType;
{

/* Initial. */

}
interface

uses
  JS;

type
  TAddressType = class
  private
    fAddressKey: String;
    fStreetName: String;
    fHouseNumber: String;
    fExtension: String;
    fPostalCode: String;
    fCity: String;
    fCountry: String;
  public
    property AddressKey: String read fAddressKey;
    property StreetName: String read fStreetName;
    property HouseNumber: String read fHouseNumber;
    property Extension: String read fExtension;
    property PostalCode: String read fPostalCode;
    property City: String read fCity;
    property Country: String read fCountry;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TAddressType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fAddressKey := String(JSObject_Type['addressKey']);
    fStreetName := String(JSObject_Type['streetName']);
    fHouseNumber := String(JSObject_Type['houseNumber']);
    fExtension := String(JSObject_Type['extension']);
    fPostalCode := String(JSObject_Type['postalCode']);
    fCity := String(JSObject_Type['city']);
    fCountry := String(JSObject_Type['country']);
  end;
end;

end.
